<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="操作时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import { filterEmpty } from '@/utils'

export default {
  data() {
    return {
      dateTime: [],
      query: {}
    }
  },
  methods: {
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => managecustomerwalletApi.exportRefundDetail(filterEmpty(this.query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    }
  }
}
</script>
